// shared.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TriggerEvents {
  private selectionSource = new BehaviorSubject<string | null>(null);
  selection$ = this.selectionSource.asObservable();
  private headerToggleSource = new BehaviorSubject<boolean>(true);
  headerToggle$ = this.headerToggleSource.asObservable();
  private backNavigationSubject = new BehaviorSubject<boolean>(false);
  backNavigation$ = this.backNavigationSubject.asObservable();

  updateSelection(value: string) {
    this.selectionSource.next(value);
  }

  setHeaderToggle(value: boolean) {
    this.headerToggleSource.next(value);
  }
  triggerBackNavigation(trigger: boolean) {
    this.backNavigationSubject.next(trigger);
  }
}
